module.exports = __webpack_public_path__ + "img/l4.80a2ad54.jpg";